import React, { useState } from 'react'
import './SelfAssessment.scss'
import Select from "react-select"
import InputField from 'components/InputField'
import Button from 'components/Button'
import { selfAssesment } from 'core/services/api'
import Toast from 'components/Toast'
import SurveyComponent from "pages/RMO/components/cancerTemplate/Template"
import { useHistory } from 'react-router'
import EmergencyAccessProtocol from 'pages/EmergencyAccessProtocol/EmergencyAccessProtocol'
import PedigreeView from 'pages/PatientClinicalView/components/GeneticCounsellor/components/PedigreeView/PedigreeView'


export const SelfAssessment = () => {
  const [planofaction, setPlanOfAction] = useState<any>()
  const [selfData, setSelfData] = useState<any>(false)
  const queryParameters = new URLSearchParams(window?.location?.search)
  const medicalRecordId: any = queryParameters?.get("medicalRecordId")
  const [assessmentData, setAssessmentData] = useState<any>({
    lastChemoDate: "",
    symptoms: [],
    feelings: "",
    FeelingComfortableInputVal: "",
    FeverInputVal: "",
    FeverOption: "",
    LooseMotionsInputVal: "",
    LooseMotionsOption: "",
    VomitingInputVal: "",
    VomitingOption: "",
    "Abdominal pain/burning": "",
    "AbdominalPain/burningInputVal": "",
    "AbdominalPain/burningOption": "",
    abdominalpainburning: "",
    abdominalpainburning2: "",
    abdominalpainburningrate: "",
    ConstipationInputVal: "",
    ConstipationOption: "",
    BodyacheInputVal: "",
    MouthUlcersInputVal: "",
    MouthUlcersOption: "",
    HiccupsInputVal: "",
    HiccupsOption: "",
    WeaknessInputVal: "",
    WeaknessOption: "",
    OxygenLevels: "",
    BP: "",
    cbcdone: "",
    HBValue: "",
    WBCCount: "",
    ANCCount: "",
    PlateletCount: ""
  })
  const templateJSON = {
    "logoPosition": "right",
    "pages": [
      {
        "name": "page1",
        "elements": [
          {
            "type": "signaturepad",
            "penColor": "black",
            "name": "consultantSign",
            "title": "Consultant Sign",
            "hideNumber": true
          },
        ],
        "readOnly": true
      }
    ],
    "showNavigationButtons": "none",
    "showPageTitles": false,
    "showCompletedPage": false
  }
  const [signatureJson, setSignatureJson] = useState<any>(templateJSON)
  const [signatureData, setSignatureData] = useState<any>({})
  const [docsPayment, setDocsPayment] = useState<any>([])

  const updateSurveyData = (data: any) => {
    setSignatureData(data)
  }

  const CBCdone = {
    CBCList: ["Yes", "No"],
  }
  const ANCList = {
    ANCListing: ["< 500, 500-1000", " 1000-1500", ">1500"]
  }
  const PlateletsList = {
    plateletsListing: ["< 500, 500-1000", " 1000-1500", ">1500"]
  }
  const WBCList = {
    wbclisting: ["< 1000, < 3000", "3000-11000", "> 11000"]
  }
  const Feeling = {
    feelingReason: ["Comfortable", "Not Comfortable"],
  }
  const OxygenLevels = {
    oxygenlevel: ["< 90%", "> 90%"],
  }

  const BPList = {
    bplisting: ["<100/60 mmhg, 100/60- 140/90 mmhg", "> 140/90 mmhg"]
  }
  const HB = {
    hbListing: ["<10g/dl", "8-10 g/dl", "< 8g/dl", "< 6g/dl"]
  }
  const WeeknessList = {
    weeknessReason: ["Yes", "No"]
  }
  const WeeknessDaily = {
    weeknessDaliyReason: ["Limiting daily activities- yes", "Limiting daily activities- no"]
  }
  const HiccupsList = {
    hiccupsLists: ["Yes", "No"]
  }
  const Fever = {
    feverReason: ["Yes", "No"],
  }
  const BodyacheList = {
    bodyachereasoning: ["Yes", "No"],
  }
  const BodyachedaliyList = {
    bodyachelistreasoning: ["Limiting daily activities Yes", "Limiting daily activities No"],
  }
  const constipationdaliyList = {
    constipationdaliyListreasoning: ["If not passed more than or equal to 3 days", "If not passed more than or equal to 3 days"],
  }
  const Temperature = {
    temps: [">100 F Temperature", "<100 F Temperature"]
  }
  const MouthUlcerList = {
    mouthulcer: ["Yes", "No"]
  }
  const MouthUlcerListReason = {
    mouthulcerReason: ["Able to eat/drink- Yes", "Able to eat/drink- No"]
  }
  const HipcusReason = {
    hipcusReason: ["Interferes with sleep or self-care activity-yes", "Interferes with sleep or self-care activity-No"]
  }
  const LooseMotion = {
    loosemotionsReason: ["Yes", "No"]
  }
  const rateofLooseMotion = {
    motionRange: [">6 Motions Perday", "<6 Motions Perday"]
  }
  const Vomiting = {
    vomitingReason: ["Yes", "No"]
  }
  const Abdominalpain_burningList = {
    abdominalpain_burningReason: ["Yes", "No"]
  }
  const Abdominalpain_burningranges = {
    abdominalpain_burningrange: ["Severe", "Mild"]
  }
  const VomitingRanges = {
    vomitingrangeReason: ["> 6 episodes in 24 Hr", "< 6 episodes in 24 Hr"]
  }
  const ConstipationList = {
    constipationReason: ["Yes", "No"]
  }
  const anclist: any = ANCList?.ANCListing.map((ele: any) => {
    return { label: ele, value: ele }
  })
  const BpListing: any = BPList?.bplisting.map((ele: any) => {
    return { label: ele, value: ele }
  })
  const Hblisting: any = HB?.hbListing.map((ele: any) => {
    return { label: ele, value: ele }
  })
  const OxygenLevelList: any = OxygenLevels?.oxygenlevel.map((ele: any) => {
    return { label: ele, value: ele }
  })
  const FeelingList: any = Feeling?.feelingReason.map((ele: any) => {
    return { label: ele, value: ele }
  })
  const FeverList: any = Fever?.feverReason.map((ele: any) => {
    return { label: ele, value: ele }
  })
  const TemperatureList: any = Temperature?.temps.map((ele: any) => {
    return { label: ele, value: ele }
  })
  const LooseMotionList: any = LooseMotion?.loosemotionsReason.map((ele: any) => {
    return { label: ele, value: ele }
  })
  const motionrangelist: any = rateofLooseMotion?.motionRange.map((ele: any) => {
    return { label: ele, value: ele }
  })
  const VomitingList: any = Vomiting?.vomitingReason.map((ele: any) => {
    return { label: ele, value: ele }
  })
  const vomitingrange: any = VomitingRanges?.vomitingrangeReason.map((ele: any) => {
    return { label: ele, value: ele }
  })
  const Cbclevels: any = CBCdone?.CBCList.map((ele: any) => {
    return { label: ele, value: ele }
  })
  const WBCLiting: any = WBCList?.wbclisting.map((ele: any) => {
    return { label: ele, value: ele }
  })
  const Abdominalpain_burninglist: any = Abdominalpain_burningList?.abdominalpain_burningReason.map((ele: any) => {
    return { label: ele, value: ele }
  })
  const Abdominalpain_burningRange: any = Abdominalpain_burningranges?.abdominalpain_burningrange.map((ele: any) => {
    return { label: ele, value: ele }
  })
  const constipationList: any = ConstipationList?.constipationReason.map((ele: any) => {
    return { label: ele, value: ele }
  })
  const bodyAcheList: any = BodyacheList?.bodyachereasoning.map((ele: any) => {
    return { label: ele, value: ele }
  })
  const bodyAchedaliyList: any = BodyachedaliyList?.bodyachelistreasoning.map((ele: any) => {
    return { label: ele, value: ele }
  })
  const constipationdaliyLists: any = constipationdaliyList?.constipationdaliyListreasoning.map((ele: any) => {
    return { label: ele, value: ele }
  })
  const mouthUlcerList: any = MouthUlcerList?.mouthulcer.map((ele: any) => {
    return { label: ele, value: ele }
  })
  const mouthUlcerReason: any = MouthUlcerListReason?.mouthulcerReason.map((ele: any) => {
    return { label: ele, value: ele }
  })
  const HiccupsLists: any = HiccupsList?.hiccupsLists.map((ele: any) => {
    return { label: ele, value: ele }
  })
  const HippcusReason: any = HipcusReason?.hipcusReason.map((ele: any) => {
    return { label: ele, value: ele }
  })
  const weeknessListing: any = WeeknessList?.weeknessReason.map((ele: any) => {
    return { label: ele, value: ele }
  })
  const weeknessListingReason: any = WeeknessDaily?.weeknessDaliyReason.map((ele: any) => {
    return { label: ele, value: ele }
  })

  const [displayToast, toggleDisplayToast] = useState<any>();
  function handleSelfAssesment() {
    // let medicalRecordsId = "8B87DD0E-D190-4262-9556-8F7CD137CDF8"
    selfAssesment(medicalRecordId, assessmentData).then((res) => {
      setPlanOfAction(res)
      const temp: any = {}
      temp["consultantSign"] = res?.consultantSignatureUrl
      setSignatureData(temp)
      setSelfData(true)
    })
      .catch((err: any) => {
        console.log(err, "Err")
        toggleDisplayToast({
          message: `${err?.response?.data?.message}`,
          type: "error",
        })
      })
  }

  const [patientDetails, setPatientDetails] = useState<any>()
  const history = useHistory()

  const TreatmentScreen = ({ signatureData, signatureJson, setSignatureData, updateSurveyData }: any) => {
    const renderPoa = () => {
      console.log(planofaction?.staffs && planofaction?.staffs?.length > 0 && planofaction?.staffs[0]?.name, "planofaction");
      if (planofaction?.poa || planofaction?.staff) {
        const symptoms = Object?.keys(planofaction?.poa);
        return (
          <>
            <ol className="poa-container" style={{ listStyleType: 'none', counterReset: 'none' }}>
              {symptoms.map((symptom, index) => (
                <div>
                  <li key={index} className="sectionTitle">
                    <span className="label">{String.fromCharCode(97 + index)}. </span>
                    {symptom}
                  </li>
                  <ol className="treatment-list">
                    {planofaction?.poa[symptom]?.map((treatment: any, treatmentIndex: any) => (
                      <li key={treatmentIndex} className="treatment">
                        {treatment}
                      </li>
                    ))}
                  </ol>
                </div>
              ))}
            </ol>
          </>
        );
      } else {
        return null;
      }
    };



    return <div className="container">{renderPoa()}
      <div className="poa-signature-container">
        <SurveyComponent
          css={""}
          data={signatureData}
          json={signatureJson}
          onComplete={(survey: any) => {
            const data = survey.data
            setSignatureData(data)
            // handleSurveyCompletion()
          }}
          updateFlag={updateSurveyData}
        />
      </div>
      <div>
        <EmergencyAccessProtocol />
        <div style={{ float: "right", marginTop: "18px" }}>
          <Button text="Home" onClick={() => history.push('/')} />

        </div>
      </div>
    </div>;
  };


  return (
    <div className='selfAssessment-wrapper'>
      <div>
        {!selfData &&
          <><div className='greeting'>
            <div className="heading">SelfAssesment Form</div>
            <h1 className='mt-2 greeting_moc'>Greetings From MOC !</h1>
            <p className='mt-2'>
              In case the patient is unconscious/disoriented, breathless, has convulsions, persistent uncontrolled diarrhoea, continuous high-grade fever and any other emergency condition
            </p>

          </div>
            <div className='mt-5'>
              <label>
                How are you feeling?
              </label>
              <div className='d-flex col-md-6'>
                <Select
                  options={FeelingList}
                  // defaultValue={FeelingList}
                  onChange={(option: any) => {
                    const temp = [...assessmentData?.symptoms]
                    // temp.push("Feeling") // modify here to push the label "Fever"
                    setAssessmentData({
                      ...assessmentData,
                      feelings: option?.value,
                      symptoms: temp
                    })
                  }}
                  placeholder="How are you feeling?" />


                <div className='' style={{ marginLeft: "19px" }}>
                  {assessmentData.feelings === "Not Comfortable" &&

                    <>
                      <div className='d-flex col-md-6'>

                        <InputField
                          handleChange={(e: any) => {
                            const newValue = e?.target?.value
                            if (!isNaN(newValue) && newValue >= 0) {
                              setAssessmentData({
                                ...assessmentData,
                                FeelingComfortableInputVal: newValue,
                              })
                            }
                            else {
                              setAssessmentData({
                                ...assessmentData,
                                FeelingComfortableInputVal: 0,
                              })
                            }
                          }}
                          type="number"
                          value={assessmentData?.FeelingComfortableInputVal}
                        />
                        &nbsp;<div className='mt-2'>Days</div>
                      </div>

                    </>}
                </div>
              </div>
              <div className='d-flex mt-5'>
                <div className='mt-2'>
                  <h1>Last chemotherapy taken date&nbsp;-&nbsp;</h1>
                </div>
                <InputField
                  className="col-md-2"
                  placeholder="Last Chemotherapy Taken Date"
                  value={assessmentData?.lastChemoDate}
                  handleChange={(e) => {
                    const selectedDate = e.target.value;
                    const currentDate = new Date().toISOString().split('T')[0];

                    // Check if the selected date is a future date
                    if (selectedDate > currentDate) {
                      // If it's a future date, set the input value to the current date
                      e.target.value = currentDate;

                      // Update the state with the current date
                      setAssessmentData({
                        ...assessmentData,
                        lastChemoDate: currentDate,
                      });
                    } else {
                      // If it's a valid date, update the state with the selected date
                      setAssessmentData({
                        ...assessmentData,
                        lastChemoDate: selectedDate,
                      });
                    }
                  }}
                  type="date"
                  max={new Date().toISOString().split('T')[0]} // Set the max attribute to disable future dates
                />
              </div>
              <h1 className='heading mt-5'>Do you have the following symptoms-</h1>
              <div className='mt-5 d-flex'>
                <label className='mt-2 col-md-2'>Fever &nbsp;&nbsp;</label>
                <Select
                  className='col-md-2'
                  options={FeverList}
                  defaultValue={FeverList}
                  onChange={(option: any) => {
                    if (option?.value === "Yes") {
                      const temp = [...assessmentData?.symptoms]
                      temp.push("Fever") // modify here to push the label "Fever"
                      setAssessmentData({
                        ...assessmentData,
                        fevers: option?.value,
                        symptoms: temp
                      })
                    } else {
                      const temp = [...assessmentData?.symptoms]
                      if (temp?.includes("Fever")) {
                        const index = temp.indexOf("Fever");
                        if (index > -1) {
                          temp.splice(index, 1);
                        }
                      }
                      setAssessmentData({
                        ...assessmentData,
                        fevers: option?.value,
                        FeverInputVal: "",
                        FeverOption: "",
                        symptoms: temp
                      })
                    }
                  }}
                  placeholder="Fever"
                  value={FeverList.filter(
                    ({ label }: any) => label === assessmentData.fevers
                  )}
                />
                <div className='d-flex' style={{ marginLeft: "21px" }}>
                  {assessmentData.fevers === "Yes" &&
                    <>
                      <div className='d-flex col-md-3 constipation_width'>
                        <InputField
                          handleChange={(e: any) => {
                            const newValue = e?.target.value
                            if (!isNaN(newValue) && newValue >= 0) {
                              setAssessmentData({
                                ...assessmentData,
                                FeverInputVal: newValue,
                              })
                            }
                            else {
                              setAssessmentData({
                                ...assessmentData,
                                FeverInputVal: 0,
                              })
                            }
                          }}
                          type="number"
                          value={assessmentData?.FeverInputVal}
                        />
                        <div className='mt-2'>&nbsp;&nbsp;Days</div>
                      </div>
                      <div className='col-md-8' style={{ marginLeft: "21px", width: "185px" }}>
                        <Select
                          options={TemperatureList}
                          defaultValue={TemperatureList}
                          onChange={(option: any) => {
                            const temp = { ...assessmentData }
                            temp.FeverOption = option?.value// modify here to push the label "Fever"
                            setAssessmentData(temp)
                          }}
                          placeholder="Temperature"
                          value={TemperatureList.filter(
                            ({ label }: any) => label === assessmentData.FeverOption
                          )} />
                      </div>
                    </>}

                </div>
              </div>
              <div className='mt-5 d-flex'>
                <label className='col-md-2'>Loose Motions &nbsp; &nbsp;</label>
                <Select
                  className='col-md-2'
                  options={LooseMotionList}
                  defaultValue={LooseMotionList}
                  onChange={(option: any) => {
                    if (option?.value === "Yes") {
                      const temp = [...assessmentData.symptoms]
                      temp.push("Loose motions")
                      setAssessmentData({
                        ...assessmentData,
                        loosemotion: option?.value,
                        symptoms: temp
                      })
                    } else {
                      const temp = [...assessmentData?.symptoms]
                      if (temp?.includes("Loose motions")) {
                        const index = temp.indexOf("Loose motions");
                        if (index > -1) {
                          temp.splice(index, 1);
                        }
                      }
                      setAssessmentData({
                        ...assessmentData,
                        loosemotion: option?.value,
                        LooseMotionsInputVal: "",
                        LooseMotionsOption: "",
                        symptoms: temp
                      })
                    }
                  }}
                  placeholder="Loose Motion"
                  value={LooseMotionList.filter(
                    ({ label }: any) => label === assessmentData.loosemotion
                  )} />
                <div className='d-flex' style={{ marginLeft: "21px" }}>
                  {assessmentData.loosemotion === "Yes" &&

                    <>
                      <div className='d-flex col-md-3 constipation_width'>
                        <InputField
                          handleChange={(e: any) => {
                            const newValue = e?.target.value
                            if (!isNaN(newValue) && newValue >= 0) {
                              setAssessmentData({
                                ...assessmentData,
                                LooseMotionsInputVal: newValue,
                              })
                            }
                            else {
                              setAssessmentData({
                                ...assessmentData,
                                LooseMotionsInputVal: 0,
                              })
                            }
                          }}
                          type="number"
                          value={assessmentData?.LooseMotionsInputVal}
                        />
                        <div className='mt-2'>&nbsp;&nbsp;Days</div>
                      </div>
                      <div className='col-md-8' style={{ marginLeft: "21px", width: "185px" }}>
                        <Select
                          options={motionrangelist}
                          defaultValue={motionrangelist}
                          onChange={(option: any) => {
                            const temp = { ...assessmentData }
                            temp.LooseMotionsOption = option?.value// modify here to push the label "Fever"
                            setAssessmentData(temp)
                          }}
                          placeholder="Motion Range"
                          value={motionrangelist.filter(
                            ({ label }: any) => label === assessmentData.LooseMotionsOption
                          )} />
                      </div>
                    </>}

                </div>
              </div>

              <div className='mt-5 d-flex'>
                <label className='col-md-2'>Vomiting &nbsp;&nbsp;</label>
                <Select
                  className='col-md-2'
                  options={VomitingList}
                  defaultValue={VomitingList}
                  onChange={(option: any) => {
                    if (option?.value === "Yes") {
                      const temp = [...assessmentData.symptoms]
                      temp.push("Vomiting")
                      setAssessmentData({
                        ...assessmentData,
                        vomiting: option?.value,
                        symptoms: temp
                      })
                    } else {
                      const temp = [...assessmentData?.symptoms]
                      if (temp?.includes("Vomiting")) {
                        const index = temp.indexOf("Vomiting");
                        if (index > -1) {
                          temp.splice(index, 1);
                        }
                      }
                      setAssessmentData({
                        ...assessmentData,
                        vomiting: option?.value,
                        VomitingInputVal: "",
                        VomitingOption: "",
                        symptoms: temp
                      })
                    }
                  }}
                  placeholder="Vomiting"
                  value={VomitingList.filter(
                    ({ label }: any) => label === assessmentData.vomiting
                  )} />
                <div className='d-flex' style={{ marginLeft: "21px" }}>
                  {assessmentData.vomiting === "Yes" &&
                    <>
                      <div className='d-flex col-md-2 constipation_width'>

                        <InputField
                          handleChange={(e: any) => {
                            const newValue = e?.target.value
                            if (!isNaN(newValue) && newValue >= 0) {
                              setAssessmentData({
                                ...assessmentData,
                                VomitingInputVal: newValue,
                              })
                            }
                            else {
                              setAssessmentData({
                                ...assessmentData,
                                VomitingInputVal: 0,
                              })
                            }
                          }}
                          type="number"
                          value={assessmentData?.VomitingInputVal}
                        />
                        <div className='mt-2'>&nbsp;&nbsp;Days</div>
                      </div>
                      <div className='col-md-8' style={{ marginLeft: "21px", width: "185px" }}>
                        <Select
                          options={vomitingrange}
                          defaultValue={vomitingrange}
                          onChange={(option: any) => {
                            const temp = { ...assessmentData }
                            temp.VomitingOption = option?.value// modify here to push the label "Fever"
                            setAssessmentData(temp)
                          }}
                          placeholder="Vomiting Range"
                          value={vomitingrange.filter(
                            ({ label }: any) => label === assessmentData.VomitingOption
                          )} />
                      </div>
                    </>}

                </div>
              </div>
              <div className='mt-5 d-flex'>
                <label className='col-md-2'>Abdominal pain/burning  &nbsp;&nbsp;</label>
                <Select
                  className='col-md-2'
                  options={Abdominalpain_burninglist}
                  defaultValue={Abdominalpain_burninglist}
                  onChange={(option: any) => {
                    if (option?.value === "Yes") {
                      const temp = [...assessmentData.symptoms]
                      temp.push("Abdominal pain/burning")
                      setAssessmentData({
                        ...assessmentData,
                        "Abdominal pain/burning": option?.value,
                        symptoms: temp
                      })
                    } else {
                      const temp = [...assessmentData?.symptoms]
                      if (temp?.includes("Abdominal pain/burning")) {
                        const index = temp.indexOf("Abdominal pain/burning");
                        if (index > -1) {
                          temp.splice(index, 1);
                        }
                      }
                      setAssessmentData({
                        ...assessmentData,
                        "Abdominal pain/burning": option?.value,
                        "AbdominalPain/burningInputVal": "",
                        "AbdominalPain/burningOption": "",
                        symptoms: temp
                      })
                    }
                  }}
                  placeholder="Abdominal pain/burning"
                  value={Abdominalpain_burninglist.filter(
                    ({ label }: any) => label === assessmentData["Abdominal pain/burning"]
                  )} />
                <div className='d-flex' style={{ marginLeft: "21px" }}>
                  {assessmentData["Abdominal pain/burning"] === "Yes" &&
                    <>
                      <div className='d-flex col-md-2 constipation_width'>
                        <InputField
                          handleChange={(e: any) => {
                            const newValue = e?.target.value
                            if (!isNaN(newValue) && newValue >= 0) {
                              setAssessmentData({
                                ...assessmentData,
                                "AbdominalPain/burningInputVal": newValue,
                              })
                            }
                            else {
                              setAssessmentData({
                                ...assessmentData,
                                "AbdominalPain/burningInputVal": 0,
                              })
                            }
                          }}
                          type="number"
                          value={assessmentData["AbdominalPain/burningInputVal"]}
                        />
                        <div className='mt-2'>&nbsp;&nbsp;Days</div>
                      </div>
                      <div className='col-md-6' style={{ marginLeft: "21px", width: "185px" }}>
                        <Select
                          options={Abdominalpain_burningRange}
                          defaultValue={Abdominalpain_burningRange}
                          onChange={(option: any) => {
                            const temp = { ...assessmentData }
                            temp["AbdominalPain/burningOption"] = option?.value;
                            setAssessmentData(temp)
                          }}
                          placeholder="Abdominal pain/burning Range"
                          value={Abdominalpain_burningRange.filter(
                            ({ label }: any) => label === assessmentData["AbdominalPain/burningOption"]
                          )} />
                      </div>
                    </>}
                </div>
              </div>

              <div className='mt-5 d-flex'>
                <label className='col-md-2'>Constipation  &nbsp;&nbsp;</label>
                <Select
                  className='col-md-2'
                  options={constipationList}
                  defaultValue={constipationList}
                  onChange={(option: any) => {
                    if (option?.value === "Yes") {
                      const temp = [...assessmentData.symptoms]
                      temp.push("Constipation")
                      setAssessmentData({
                        ...assessmentData,
                        constipation: option?.value,
                        symptoms: temp
                      })
                    } else {
                      const temp = [...assessmentData?.symptoms]
                      if (temp?.includes("Constipation")) {
                        const index = temp.indexOf("Constipation");
                        if (index > -1) {
                          temp.splice(index, 1);
                        }
                      }
                      setAssessmentData({
                        ...assessmentData,
                        constipation: option?.value,
                        ConstipationInputVal: "",
                        ConstipationOption: "",
                        symptoms: temp
                      })
                    }
                  }}
                  placeholder="Constipation"
                  value={constipationList.filter(
                    ({ label }: any) => label === assessmentData.constipation
                  )} />
                <div className='d-flex' style={{ marginLeft: "21px" }}>
                  {assessmentData.constipation === "Yes" &&
                    <>
                      <div className='d-flex col-md-3 constipation_width'>
                        <InputField
                          handleChange={(e: any) => {
                            const newValue = e?.target.value
                            if (!isNaN(newValue) && newValue >= 0) {
                              setAssessmentData({
                                ...assessmentData,
                                ConstipationInputVal: newValue,
                              })
                            }
                            else {
                              setAssessmentData({
                                ...assessmentData,
                                ConstipationInputVal: 0,
                              })
                            }
                          }}
                          type="number"
                          value={assessmentData?.ConstipationInputVal}
                        />
                        <div className='mt-2'>&nbsp;&nbsp;Days</div>
                      </div>

                      <div className='col-md-8' style={{ marginLeft: "21px", width: "185px" }}>
                        <Select
                          options={constipationdaliyLists}
                          defaultValue={constipationdaliyLists}
                          onChange={(option: any) => {
                            const temp = { ...assessmentData }
                            temp.ConstipationOption = option?.value// modify here to push the label "Fever"
                            setAssessmentData(temp)
                          }}
                          placeholder="Constipation Range"
                          value={constipationdaliyLists.filter(
                            ({ label }: any) => label === assessmentData.ConstipationOption
                          )} />
                      </div>
                    </>}

                </div>
              </div>







              <div className='mt-5 d-flex' >
                <label className='col-md-2'>BodyAche  &nbsp;&nbsp;</label>
                <Select
                  className='col-md-2'
                  options={bodyAcheList}
                  defaultValue={bodyAcheList}
                  onChange={(option: any) => {
                    if (option?.value === "Yes") {
                      const temp = [...assessmentData.symptoms]
                      temp.push("Bodyache")
                      setAssessmentData({
                        ...assessmentData,
                        bodyache: option?.value,
                        symptoms: temp
                      })
                    } else {
                      const temp = [...assessmentData?.symptoms]
                      if (temp?.includes("Bodyache")) {
                        const index = temp.indexOf("Bodyache");
                        if (index > -1) {
                          temp.splice(index, 1);
                        }
                      }
                      setAssessmentData({
                        ...assessmentData,
                        bodyache: option?.value,
                        BodyacheInputVal: "",
                        BodyacheOption: "",
                        symptoms: temp
                      })
                    }
                  }}
                  placeholder="BodyAche"
                  value={bodyAcheList.filter(
                    ({ label }: any) => label === assessmentData.bodyache
                  )} />
                <div className='d-flex' style={{ marginLeft: "21px" }}>
                  {assessmentData.bodyache === "Yes" &&
                    <>
                      <div className='d-flex col-md-3 constipation_width'>

                        <InputField
                          handleChange={(e: any) => {
                            const newValue = e?.target.value
                            if (!isNaN(newValue) && newValue >= 0) {
                              setAssessmentData({
                                ...assessmentData,
                                BodyacheInputVal: newValue,
                              })
                            }
                            else {
                              setAssessmentData({
                                ...assessmentData,
                                BodyacheInputVal: 0,
                              })
                            }
                          }}
                          type="number"
                          value={assessmentData?.BodyacheInputVal}
                        />
                        <div className='mt-2'>&nbsp;&nbsp;Days</div>
                      </div>
                      <div className='col-md-8' style={{ marginLeft: "21px", width: "185px" }}>
                        <Select
                          options={bodyAchedaliyList}
                          defaultValue={bodyAchedaliyList}
                          onChange={(option: any) => {
                            const temp = { ...assessmentData }
                            temp.BodyacheOption = option?.value// modify here to push the label "Fever"
                            setAssessmentData(temp)
                          }}
                          placeholder="Body Ache Range"
                          value={bodyAchedaliyList.filter(
                            ({ label }: any) => label === assessmentData.BodyacheOption
                          )} />
                      </div>
                    </>}

                </div>
              </div>

              <div className='mt-5 d-flex'>
                <label className='col-md-2'>Mouth ulcers  &nbsp;&nbsp;</label>
                <Select
                  className='col-md-2'
                  options={mouthUlcerList}
                  defaultValue={mouthUlcerList}
                  onChange={(option: any) => {
                    if (option?.value === "Yes") {
                      const temp = [...assessmentData.symptoms]
                      temp.push("Mouth ulcers")
                      setAssessmentData({
                        ...assessmentData,
                        mouthulcer: option?.value,
                        symptoms: temp
                      })
                    } else {
                      const temp = [...assessmentData?.symptoms]
                      if (temp?.includes("Mouth ulcers")) {
                        const index = temp.indexOf("Mouth ulcers");
                        if (index > -1) {
                          temp.splice(index, 1);
                        }
                      }
                      setAssessmentData({
                        ...assessmentData,
                        mouthulcer: option?.value,
                        MouthUlcersInputVal: "",
                        MouthUlcersOption: "",
                        symptoms: temp
                      })
                    }
                  }}
                  placeholder="Mouth Ulcer"
                  value={mouthUlcerList.filter(
                    ({ label }: any) => label === assessmentData.mouthulcer
                  )} />
                <div className='d-flex' style={{ marginLeft: "21px" }}>
                  {assessmentData.mouthulcer === "Yes" &&
                    <>
                      <div className='d-flex col-md-3 constipation_width'>

                        <InputField
                          // className='mouthulcer_width'
                          handleChange={(e: any) => {
                            const newValue = e?.target.value
                            if (!isNaN(newValue) && newValue >= 0) {
                              setAssessmentData({
                                ...assessmentData,
                                MouthUlcersInputVal: newValue,
                              })
                            }
                            else {
                              setAssessmentData({
                                ...assessmentData,
                                MouthUlcersInputVal: 0,
                              })
                            }
                          }}
                          type="number"
                          value={assessmentData?.MouthUlcersInputVal}
                        />
                        <div className='mt-2'>&nbsp;&nbsp;Days</div>
                      </div>
                      <div className='col-md-8' style={{ marginLeft: "21px", width: "185px" }}>
                        <Select
                          options={mouthUlcerReason}
                          defaultValue={mouthUlcerReason}
                          onChange={(option: any) => {
                            const temp = { ...assessmentData }
                            temp.MouthUlcersOption = option?.value// modify here to push the label "Fever"
                            setAssessmentData(temp)
                          }}
                          placeholder="MouthUlcers Range"
                          value={mouthUlcerReason.filter(
                            ({ label }: any) => label === assessmentData.MouthUlcersOption
                          )} />
                      </div>
                    </>}

                </div>
              </div>

              <div className='mt-5 d-flex'>
                <label className='col-md-2'>Hiccups &nbsp;&nbsp;</label>
                <Select
                  className='col-md-2'
                  options={HiccupsLists}
                  defaultValue={HiccupsLists}
                  onChange={(option: any) => {
                    if (option?.value === "Yes") {
                      const temp = [...assessmentData.symptoms]
                      temp.push("Hiccups")
                      setAssessmentData({
                        ...assessmentData,
                        hiccups: option?.value,
                        symptoms: temp
                      })
                    } else {
                      const temp = [...assessmentData?.symptoms]
                      if (temp?.includes("Hiccups")) {
                        const index = temp.indexOf("Hiccups");
                        if (index > -1) {
                          temp.splice(index, 1);
                        }
                      }
                      setAssessmentData({
                        ...assessmentData,
                        hiccups: option?.value,
                        HiccupsInputVal: "",
                        HiccupsOption: "",
                        symptoms: temp
                      })
                    }
                  }}
                  placeholder="Hiccups"
                  value={HiccupsLists.filter(
                    ({ label }: any) => label === assessmentData.hiccups
                  )} />
                <div className=' d-flex' style={{ marginLeft: "21px" }}>
                  {assessmentData.hiccups === "Yes" &&
                    <>
                      <div className='d-flex col-md-3 constipation_width'>

                        <InputField
                          // className='hicupps_width'
                          handleChange={(e: any) => {
                            const newValue = e?.target.value
                            if (!isNaN(newValue) && newValue >= 0) {
                              setAssessmentData({
                                ...assessmentData,
                                HiccupsInputVal: newValue,
                              })
                            }
                            else {
                              setAssessmentData({
                                ...assessmentData,
                                HiccupsInputVal: 0,
                              })
                            }
                          }}
                          type="number"
                          value={assessmentData?.HiccupsInputVal}
                        />
                        <div className='mt-2'>&nbsp;&nbsp;Days</div>
                      </div>
                      <div className='col-md-9' style={{ marginLeft: "21px", width: "185px" }}>
                        <Select
                          options={HippcusReason}
                          defaultValue={HippcusReason}
                          onChange={(option: any) => {
                            const temp = { ...assessmentData }
                            temp.HiccupsOption = option?.value// modify here to push the label "Fever"
                            setAssessmentData(temp)
                          }}
                          placeholder="Hiccups Range"
                          value={HippcusReason.filter(
                            ({ label }: any) => label === assessmentData.HiccupsOption
                          )} />
                      </div>
                    </>}

                </div>
              </div>

              <div className='mt-5 d-flex'>
                <label className='col-md-2'>Weekness &nbsp;&nbsp;</label>
                <Select
                  className='col-md-2'
                  options={weeknessListing}
                  defaultValue={weeknessListing}
                  onChange={(option: any) => {
                    if (option?.value === "Yes") {
                      const temp = [...assessmentData.symptoms]
                      temp.push("Weakness")
                      setAssessmentData({
                        ...assessmentData,
                        weakness: option?.value,
                        symptoms: temp
                      })
                    } else {
                      const temp = [...assessmentData?.symptoms]
                      if (temp?.includes("Weakness")) {
                        const index = temp.indexOf("Weakness");
                        if (index > -1) {
                          temp.splice(index, 1);
                        }
                      }
                      setAssessmentData({
                        ...assessmentData,
                        weakness: option?.value,
                        WeaknessInputVal: "",
                        WeaknessOption: "",
                        symptoms: temp
                      })
                    }
                  }}
                  placeholder="Weekness"
                  value={weeknessListing.filter(
                    ({ label }: any) => label === assessmentData.weakness
                  )} />
                <div className='d-flex' style={{ marginLeft: "21px" }}>
                  {assessmentData.weakness === "Yes" &&
                    <>
                      <div className='d-flex col-md-3 constipation_width'>

                        <InputField
                          handleChange={(e: any) => {
                            const newValue = e?.target.value
                            if (!isNaN(newValue) && newValue >= 0) {
                              setAssessmentData({
                                ...assessmentData,
                                WeaknessInputVal: newValue,
                              })
                            }
                            else {
                              setAssessmentData({
                                ...assessmentData,
                                WeaknessInputVal: 0,
                              })
                            }
                          }}
                          type="number"
                          value={assessmentData?.WeaknessInputVal}
                        />
                        <div className='mt-2'>&nbsp;&nbsp;Days</div>
                      </div>
                      <div className='col-md-8' style={{ marginLeft: "21px", width: "185px" }}>
                        <Select
                          options={weeknessListingReason}
                          defaultValue={weeknessListingReason}
                          onChange={(option: any) => {
                            const temp = { ...assessmentData }
                            temp.WeaknessOption = option?.value// modify here to push the label "Fever"
                            setAssessmentData(temp)
                          }}
                          placeholder="Weekness Range"
                          value={weeknessListingReason.filter(
                            ({ label }: any) => label === assessmentData.WeaknessOption
                          )} />
                      </div>
                    </>}

                </div>
              </div>

              <div className='d-flex'>
                <div className='mt-5 col-md-2'>
                  <label>Oxygen Level  &nbsp;&nbsp;</label>
                  <Select
                    options={OxygenLevelList}
                    defaultValue={OxygenLevelList}
                    onChange={(option: any) => {
                      const temp = [...assessmentData.symptoms]
                      // temp.push(option.value)
                      setAssessmentData({
                        ...assessmentData,
                        OxygenLevels: option?.value,
                        symptoms: temp
                      })

                    }}
                    placeholder="Oxygen Level"
                    value={OxygenLevelList.filter(
                      ({ label }: any) => label === assessmentData.OxygenLevels
                    )} />
                </div>
                <div className='mt-5 col-md-2' style={{ marginLeft: "20px" }}>
                  <label>BP&nbsp;&nbsp;</label>
                  <Select
                    options={BpListing}
                    defaultValue={BpListing}
                    onChange={(option: any) => {
                      const temp = [...assessmentData.symptoms]
                      // temp.push(option.value)
                      setAssessmentData({
                        ...assessmentData,
                        BP: option?.value,
                        symptoms: temp
                      })

                    }}
                    placeholder="BP"
                    value={BpListing.filter(
                      ({ label }: any) => label === assessmentData.BP
                    )} />


                </div>
              </div>


              <div className='mt-5'>
                <label>CBC Done &nbsp;&nbsp;</label>
                <Select
                  className='col-md-2'
                  options={Cbclevels}
                  defaultValue={Cbclevels}
                  onChange={(option: any) => {

                    // setAssessmentData({
                    //   ...assessmentData,
                    //   cbcdone: option?.value,
                    // })
                    const temp = [...assessmentData.symptoms]
                    // temp.push(option.value)
                    setAssessmentData({
                      ...assessmentData,
                      cbcdone: option?.value,
                      symptoms: temp
                    })

                  }}
                  placeholder="CBC done"
                  value={Cbclevels.filter(
                    ({ label }: any) => label === assessmentData.cbcdone
                  )} />
              </div>
              <div className='mt-5'>
                {assessmentData.cbcdone === "Yes" &&
                  <>
                    <div>
                      {/* <DetailedDocument patientDetail={patientDetails} /> */}
                      <PedigreeView
                        docs={docsPayment}
                        patient={patientDetails}
                        type={"BookAppointment"}
                        medicalRecordId={medicalRecordId}
                        uploadDocument={(documents: any) => {
                          setDocsPayment(documents);
                        }}
                      />
                      <div className='d-flex mt-2'>
                        <div className='mt-5 col-md-3'>
                          <label>HB &nbsp;&nbsp;</label>
                          <Select
                            options={Hblisting}
                            defaultValue={Hblisting}
                            onChange={(option: any) => {
                              // temp.push(option.value)
                              setAssessmentData({
                                ...assessmentData,
                                HBValue: option?.value,
                                // symptoms: temp
                              })
                            }}
                            placeholder="HB"
                            value={Hblisting.filter(
                              ({ label }: any) => label === assessmentData.HBValue
                            )} />
                        </div>
                        <div className='mt-5 col-md-3' style={{ marginLeft: "12px" }}>
                          <label>WBC</label>
                          <Select
                            options={WBCLiting}
                            defaultValue={WBCLiting}
                            onChange={(option: any) => {

                              // temp.push(option.value)
                              setAssessmentData({
                                ...assessmentData,
                                WBCCount: option?.value,
                                // symptoms: temp
                              })

                            }}
                            placeholder="WBC"
                            value={WBCLiting.filter(
                              ({ label }: any) => label === assessmentData.WBCCount
                            )} />
                        </div>

                        <div className='mt-5 col-md-3' style={{ marginLeft: "12px" }}>
                          <label>ANC &nbsp;&nbsp;</label>
                          <Select
                            options={anclist}
                            defaultValue={anclist}
                            onChange={(option: any) => {

                              // setAssessmentData({
                              //   ...assessmentData,
                              //   anc: option?.value,
                              // })
                              const temp = [...assessmentData.symptoms]
                              // temp.push(option.value)
                              setAssessmentData({
                                ...assessmentData,
                                ANCCount: option?.value,
                                symptoms: temp
                              })

                            }}
                            placeholder="WBC"
                            value={anclist.filter(
                              ({ label }: any) => label === assessmentData.ANCCount
                            )} />
                        </div>
                      </div>

                      {/* <div className='mt-2'>
                        <label>Platelets</label>
                        <Select
                          options={plateletlists}
                          defaultValue={plateletlists}
                          onChange={(option: any) => {

                            // setAssessmentData({
                            //   ...assessmentData,
                            //   platelets: option?.value,
                            // })
                            const temp = [...assessmentData.symptoms]
                            temp.push(option.value)
                            setAssessmentData({
                              ...assessmentData,
                              PlateletCount: option?.value,
                              symptoms: temp
                            })

                          }}
                          placeholder="platelets"
                          value={plateletlists.filter(
                            ({ label }: any) => label === assessmentData.PlateletCount
                          )} />
                      </div> */}
                    </div>
                  </>}

              </div>
            </div><div className='save-button mt-4'>
              <Button text="Save" id="save" onClick={() => handleSelfAssesment()}></Button>
            </div></>
        }

      </div>
      {
        selfData &&
        <div>
          <h1 style={{ textAlign: "center", marginTop: "10px" }} className='heading'>Plan Of Action</h1>
          <div className='d-flex'>
            <label className='heading_staff_name'>RMO Name:</label>
            <p style={{ textAlign: "right", marginTop: "15px" }} >{planofaction?.staffs && planofaction?.staffs?.length > 0 && planofaction?.staffs[0]?.name}</p>
          </div>
          <div className='d-flex'>
            <label className='heading_staff_name'>RMO Phone Number:</label>
            <p style={{ textAlign: "right", marginTop: "15px" }} >
              {planofaction?.staffs && planofaction?.staffs?.length > 0 && planofaction?.staffs[0]?.phoneNumber}</p>
          </div>
          <TreatmentScreen
            signatureData={signatureData}
            setSignatureData={setSignatureData}
            signatureJson={signatureJson}
            updateSurveyData={updateSurveyData}
          />
        </div>
      }
      {
        displayToast && (
          <Toast
            textMessage={displayToast?.message}
            onClose={() => {
              toggleDisplayToast(false)
            }}
            onCloseText="Close"
            onClickText={null}
            type={displayToast?.type}
          />
        )
      }
    </div >
  )
}

